import React, { useState } from 'react';
import { Button, Tag, TextField } from '@cimpress/react-components';
import { ENTER } from 'src/util/keycodes';

interface Props {
    tags: string[];
    predefinedTags: string[];
    addTag: (tags: string[]) => void;
    removeTag: (tag: string) => void;
}

const SceneTags: React.FC<Props> = ({ tags, removeTag, predefinedTags, addTag }) => {
    const [currentTag, setCurrentTag] = useState('');
    const [isDuplicateTag, setIsDuplicateTag] = useState(false);

    const updateCurrentTag = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentTag(e.target.value);
        setIsDuplicateTag(false);
    };

    const addSceneTag = () => {
        const tagSet = currentTag
            .split(',')
            .filter((tag) => tag)
            .map((tag) => tag.trim());

        if (tagSet.every((item) => tags.indexOf(item) > -1)) {
            setIsDuplicateTag(true);
        } else {
            const uniqueTagSet = Array.from(new Set([...tagSet, ...tags]));
            addTag(uniqueTagSet);
        }
        setCurrentTag('');
    };

    const onPreSetTagClick = (tag: string) => {
        if (tags.includes(tag)) {
            removeTag(tag);
        } else {
            const uniqueTagSet = Array.from(new Set([...tags, tag]));
            addTag(uniqueTagSet);
        }
    };

    return (
        <div className='save-properties'>
            <div className='save-properties__input scene-tags__list'>
                {tags &&
                    tags.map((tag) => (
                        <Tag
                            value={tag}
                            key={tag}
                            removable={true}
                            onRemoveClick={(value) => removeTag(value as string)}
                        />
                    ))}
            </div>
            <div className='save-properties'>
                <TextField
                    className='save-properties__input'
                    data-testid='editor-sceneInformation-tags-input'
                    value={currentTag}
                    label='Add a tag'
                    onChange={updateCurrentTag}
                    onKeyDown={(e) => {
                        if (e.keyCode === ENTER) {
                            addSceneTag();
                        }
                    }}
                    rightAddon={
                        <Button
                            data-testid='editor-sceneInformation-tags-submit'
                            className='scene-tag__add-button'
                            onClick={addSceneTag}
                            disabled={!currentTag}>
                            Add
                        </Button>
                    }
                    status={isDuplicateTag ? 'error' : undefined}
                    helpText={isDuplicateTag ? 'This tag has already been added to the scene.' : ''}
                />
                <div className='save-properties__default-tags'>
                    {predefinedTags?.map((tag) => (
                        <div key={tag} style={{ cursor: 'pointer' }} onClick={() => onPreSetTagClick(tag)}>
                            <Tag
                                data-testid={`link-tags_${tag}`}
                                className={tags.includes(tag) ? 'selected' : 'unselected'}
                                key={tag}
                                value={tag}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default React.memo(SceneTags);
